export default __webpack_public_path__ + "static/media/antp_coloquio_CarlosGodinez.66dc5fc9.png";